import Phaser from 'phaser';

const BG_OUTER = 0x4c0519;
const BG_INNER = 0x7f1d1d;
const GLOW = 0xfde68a;
const STAR_FILL = 0xfbbf24;
const STAR_INNER = 0xfde68a;
const STAR_CORE = 0xffffff;
const STROKE = 0x0a0f1f;

export function drawPhoton(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  g.fillStyle(GLOW, 0.45);
  g.fillCircle(0, 0, r * 0.82);

  const outerR = r * 0.8;
  const innerR = outerR * 0.42;
  drawStar(g, 0, 0, outerR, innerR, 5, STAR_FILL);

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.7)), STROKE, 1);
  drawStarStroke(g, 0, 0, outerR, innerR, 5);

  drawStar(g, 0, 0, outerR * 0.45, innerR * 0.5, 5, STAR_INNER);

  g.fillStyle(STAR_CORE, 1);
  g.fillCircle(0, 0, r * 0.12);
}

function drawStar(
  g: Phaser.GameObjects.Graphics,
  cx: number,
  cy: number,
  outerR: number,
  innerR: number,
  points: number,
  fill: number,
) {
  const pts = starPoints(cx, cy, outerR, innerR, points);
  g.fillStyle(fill, 1);
  g.beginPath();
  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
  g.closePath();
  g.fillPath();
}

function drawStarStroke(
  g: Phaser.GameObjects.Graphics,
  cx: number,
  cy: number,
  outerR: number,
  innerR: number,
  points: number,
) {
  const pts = starPoints(cx, cy, outerR, innerR, points);
  g.beginPath();
  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
  g.closePath();
  g.strokePath();
}

function starPoints(
  cx: number,
  cy: number,
  outerR: number,
  innerR: number,
  points: number,
) {
  const pts: { x: number; y: number }[] = [];
  const step = Math.PI / points;
  for (let i = 0; i < points * 2; i++) {
    const rad = i % 2 === 0 ? outerR : innerR;
    const a = -Math.PI / 2 + i * step;
    pts.push({ x: cx + rad * Math.cos(a), y: cy + rad * Math.sin(a) });
  }
  return pts;
}
